import { useEffect, useState } from "react";
import { api } from "../../lib/api";

let cache = null;
const listeners = new Set();

export const matLabel = (i) => `${i.marque || ""} ${i.modele || ""}`.trim();

export function refreshMateriel() {
  return api.get("/materiel-pv").then((r) => { cache = r.data; listeners.forEach((l) => l(cache)); return cache; });
}

export function useMateriel() {
  const [m, setM] = useState(cache);
  useEffect(() => {
    listeners.add(setM);
    if (!cache) refreshMateriel().catch(() => {});
    return () => listeners.delete(setM);
  }, []);
  return m;
}

const fits = (ond, panel) => panel?.puissance_w && ond.plage_min_w != null && ond.plage_max_w != null
  && panel.puissance_w >= ond.plage_min_w && panel.puissance_w <= ond.plage_max_w;

/** Extra updates when the panel model / quantity changes: compatible micro-inverter + quantity = ceil(n / per-device). */
export function pvAutofill(values, changedId, mat) {
  if (!mat || !["modele_panneaux", "nb_panneaux", "modele_onduleur"].includes(changedId)) return {};
  const panel = (mat.panneaux || []).find((p) => matLabel(p) === values.modele_panneaux);
  const out = {};
  let ond = (mat.onduleurs || []).find((o) => matLabel(o) === values.modele_onduleur);
  if (changedId === "modele_panneaux" && panel && (!ond || !fits(ond, panel))) {
    const best = (mat.onduleurs || []).find((o) => fits(o, panel));
    if (best) { ond = best; out.modele_onduleur = matLabel(best); }
  }
  const n = Number(values.nb_panneaux);
  if (ond && n > 0) out.nb_onduleurs = Math.ceil(n / (ond.panneaux_par_appareil || 2));
  return out;
}

export function pvWarning(values, mat) {
  if (!mat) return null;
  const panel = (mat.panneaux || []).find((p) => matLabel(p) === values.modele_panneaux);
  const ond = (mat.onduleurs || []).find((o) => matLabel(o) === values.modele_onduleur);
  if (!panel || !ond || fits(ond, panel)) return null;
  return `Le panneau ${matLabel(panel)} (${panel.puissance_w} W) n'entre pas dans la plage du ${matLabel(ond)} (${ond.plage_min_w}–${ond.plage_max_w} W).`;
}
